import { Box, Button, FormLabel, Tab, Tabs, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import WizardStep from "../../../../components/Wizard/WizardStep";
import FallbackSpinner from "../../../../materio/@core/components/spinner";
import WysiwygEditor from "../../../common2/Templating/WysiwygEditor";
import useReviewContent from "../hooks/useReviewContent";

type Props = {
    onCancel: () => void,
    onFinish: () => void,
    onPrevious: () => void,
    onAccept: (updatedText: string) => void,
    defaultText: string
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


const ResultPanel = ({ onPrevious, onFinish, onCancel, onAccept, defaultText }: Props) => {
    const { chatRequest, getResponse, result, isRunning } = useReviewContent();
    const [text, setText] = useState(defaultText);
    const [value, setValue] = useState(0);

    useEffect(() => {
        getResponse();
    }, [chatRequest])


    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };


    const handleNext = () => {
        onFinish();
    }

    const handleAccept = () => {
        onAccept(text)
        onFinish();
    }

    return (
        <WizardStep finishTitle='Accept Changes' title={isRunning ? 'Analyzing text, please wait..' : 'Results'} onFinish={isRunning ? undefined : handleAccept} onPrevious={onPrevious} onCancel={onCancel}>
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 2 }}>
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                    <Box sx={{ minHeight: 50, flex: 1, overflow: 'auto' }}>
                        {isRunning && <FallbackSpinner sx={{ height: '100%' }} />}

                        {!isRunning && <>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                    <Tab label="Content" {...a11yProps(0)} />
                                    <Tab label="Summary" {...a11yProps(1)} />
                                    <Tab label="Sentiment Analysis" {...a11yProps(2)} />
                                </Tabs>
                            </Box>
                            <TabPanel value={value} index={0}>
                                {!isRunning && result.length > 0 && <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: 4 }}>
                                    <TextField value={result[0].text} multiline rows={10} fullWidth label="Suggested Changes" />
                                    <Box>
                                        <FormLabel
                                            sx={{
                                                marginLeft: "0.71em",
                                                marginTop: "-0.71em",
                                                paddingLeft: "0.44em",
                                                paddingRight: '0.44em',
                                                zIndex: 2,
                                                backgroundColor: (theme) => theme.palette.background.paper,
                                                position: "absolute",
                                                fontSize: "0.75em",
                                                width: 'auto',
                                            }}>Original Content</FormLabel>
                                        <WysiwygEditor
                                            html={text}
                                            onChange={setText}
                                            showToolbar={false}
                                            withTokens={false}
                                        />
                                    </Box>
                                </Box>}
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                {!isRunning && result.length > 0 && <TextField value={result[1].text} multiline rows={23} fullWidth />}
                            </TabPanel>
                            <TabPanel value={value} index={2}>
                                {!isRunning && result.length > 0 && <TextField value={result[2].text} multiline rows={23} fullWidth />}
                            </TabPanel>
                        </>}
                    </Box>
                </Box>
            </Box>
        </WizardStep>
    )
}

export default ResultPanel;